import { StyledError } from './ui';
import colors from '../../../../utils/colors';

const FormError = StyledError.extend`
  width: 100%;
  background: ${colors.BRAND_RED_LIGHTEST};
`;

export default FormError;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/FormError.js